import { useMutation } from "@tanstack/react-query";
import { DataViewCondition, DataViewConfigPayload, DataViewConfigResponse } from "../types/dataViews";
import customFetch from "../utils/customFetch";
import { toast } from "react-toastify";
import { DataViewsResponse } from "../types/workflow";
import { MatchingConditionOperator } from "../constants/common";
import { useWorkflowId } from "../utils/misc";

export const usePostDataViews = () => {
  const workflowId = useWorkflowId();
  return useMutation<{ data: DataViewsResponse[]}, ErrorEvent, { payload?: {
    operator: MatchingConditionOperator;
    conditions: DataViewCondition[];
  } }>({
    mutationFn: ({ payload }) => {
      return customFetch(`/v1/dataViews/workflows/${workflowId}`, {
        method: 'POST',
        body: payload ? JSON.stringify(payload) : null
      })
      .then(async(res) => {
        const data = await res.json();
        return res.ok
          ? data
          : Promise.reject(new Error('Failed to get data views'))
      })
      .catch((err) => toast.error(err.message));
    }
  });
}

export const useGetDataViewsConfig = () => {
  const workflowId = useWorkflowId();
  return useMutation<DataViewConfigResponse, ErrorEvent>({
    mutationFn: () => {
      return customFetch(`/v1/dataViews/config?workflowId=${workflowId}`)
      .then(async(res) => {
        const data = await res.json();
        return res.ok
          ? data
          : Promise.reject(new Error('Failed to get data view config'))
      })
      .catch((err) => toast.error(err.message));
    }
  });
}

export const useCreateOrUpdateDataViewsConfig = () => {
  return useMutation<DataViewConfigResponse, ErrorEvent, { payload: DataViewConfigPayload, configId?: string }>({
    mutationFn: ({payload, configId}) => {
      const urlSuffix = configId ? `/${configId}` : '';
      return customFetch(`/v1/dataViews/config${urlSuffix}`, {
        method: configId ? 'PATCH' : 'POST',
        body: JSON.stringify(payload)
      })
      .then(async(res) => {
        const data = await res.json();
        return res.ok
          ? data
          : Promise.reject(new Error('Failed to update data view config'))
      })
      .catch((err) => toast.error(err.message));
    }
  });
}